package com.anjuros.website.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.redesign.components.TemplateToolbar
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.components.RichText
import com.anjuros.website.templates.selection.modules.Template
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.styles.SeeAllButtonSmallStyle
import com.anjuros.website.templates.selection.util.Constants
import com.anjuros.website.templates.selection.util.Constants.templateHeaderHeight
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.localStorage
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun BackToTemplatesButton(
    resKey: ResKey = ResKey.SEE_ALL_TEMPLATES,
    showArrow:Boolean = true,
    path:String = "/website-templates-uk",
    modifier: Modifier
){

    Link(
        modifier = modifier

            .textDecorationLine(TextDecorationLine.None)
        ,
        path = path
    ) {
        Box(
            modifier = SeeAllButtonSmallStyle.toModifier()
        ) {

            Row(
                modifier = Modifier.align(Alignment.Center),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(LocalText(resKey))
                if(showArrow) {
                    Span(
                        Modifier
                            .margin(left = 4.px)
                            .toAttrs()

                    ) {
                        Text("→")
                    }
                }
            }
        }
    }

}
/** The toolbar above a template preview, see [TemplateToolbar]. */
@Composable
fun TemplatesHeader(
    modifier: Modifier = Modifier,
    header:ResKey?,
    subHeader:ResKey?,
    showModeToggleSpotlight: Boolean = false,
    contentModeSelected:Boolean?,
    onChangeMode:(uiMode:UiMode) ->Unit,
    onDismissSpotlight: () -> Unit = {}){

    TemplateToolbar(
        modifier = modifier,
        title = header,
        description = subHeader,
        contentModeSelected = contentModeSelected,
        onChangeMode = onChangeMode,
        showHint = showModeToggleSpotlight,
        onDismissHint = onDismissSpotlight
    )
}

@Composable
fun TemplatesHeader(
    modifier: Modifier = Modifier,
    template:Template,
    showModeToggleSpotlight: Boolean = false,
    contentModeSelected:Boolean?,
    onChangeMode:(uiMode:UiMode) ->Unit,
    onDismissSpotlight: () -> Unit = {}){

    TemplatesHeader(

        modifier = modifier,
        header = template.header,
        subHeader = template.subheader,
        showModeToggleSpotlight = showModeToggleSpotlight,
        onDismissSpotlight = {
            localStorage.setItem(HintBoxDisplay,"true")
            onDismissSpotlight()},
        contentModeSelected = contentModeSelected,
        onChangeMode = onChangeMode
    )
}

@Composable
fun ModeToggle(
    checked: Boolean?,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier,
    leftButtonText :ResKey = ResKey.MIX_CONTENT_TEXT,
    rightButtonText :ResKey = ResKey.MIX_PLACEHOLDER_TEXT,
) {
    Row(
        modifier = modifier

            .borderRadius(5.px)
            .backgroundColor(rgb(230, 232, 236))
            .padding(4.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        // LEFT BUTTON
        Box(
            modifier = Modifier
                .flex(1)
                .id("contentMode")
                .height(100.percent)
                .borderRadius(3.px)
                .backgroundColor(
                    if (checked==true) Theme.ShowcaseButton.rgb else Colors.Transparent
                )
                .cursor(Cursor.Pointer)
                .onClick { onCheckedChange(true) },
            contentAlignment = Alignment.Center
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier.padding(topBottom = 2.px)
            ) {
                Image(
                    modifier = Modifier.margin(right = 8.px)
                        .size(16.px),
                    src = if (checked==true) "icon_content_mode.svg" else "icon_content_mode_gray.svg",
                    alt = "content mode"
                )
                Span(
                    attrs = Modifier
                        .color(if (checked==true) Colors.White else rgb(120, 120, 120))
                        .fontSize(14.px)
                        .toAttrs()
                ) {
                    Text(LocalText(leftButtonText))
                }
            }
        }

        // DIVIDER
        Box(
            modifier = Modifier
                .width(1.px)
                .height(60.percent)
                .backgroundColor(rgb(200, 200, 200))
        )

        // RIGHT BUTTON
        Box(
            modifier = Modifier
                .flex(1)
                .id("placeholderMode")
                .height(100.percent)
                .borderRadius(3.px)
                .backgroundColor(
                    if (checked==false) Theme.ShowcaseButton.rgb else Colors.Transparent
                )
                .cursor(Cursor.Pointer)
                .onClick { onCheckedChange(false) },
            contentAlignment = Alignment.Center
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                Image(
                    modifier = Modifier.margin(right = 8.px)
                        .size(16.px),
                    src = if (checked==false) "icon_placeholder_mode.svg" else "icon_placeholder_mode_gray.svg",
                    alt = "placeholder mode"
                )
                Span(
                    attrs = Modifier
                        .color(if (checked==false) Colors.White else rgb(120, 120, 120))
                        .fontSize(14.px)
                        .toAttrs()
                ) {
                    Text(LocalText(rightButtonText))
                }
            }
        }
    }
}

/** Dims the page behind the first-visit hint (wider screens; phones open the About sheet instead). */
@OptIn(DelicateApi::class)
@Composable
fun BlackOverlay(){
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .right(0.px)
            .bottom(0.px)
            .displayIfAtLeast(Breakpoint.MD)
            .backgroundColor(rgba(0, 0, 0, 0.55))
            .zIndex(50)

    )
}
